'use strict';exports.__esModule = true;var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _OMSegmentedControl = require('./OMSegmentedControl.scss');var _OMSegmentedControl2 = _interopRequireDefault(_OMSegmentedControl);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMSegmentedControl = function OMSegmentedControl(props) {var
  values = props.values,name = props.name,selectedValue = props.selectedValue,className = props.className,inReduxForm = props.inReduxForm,onChange = props.onChange,_props$theme = props.theme,theme = _props$theme === undefined ? '' : _props$theme;
  var handleChange = function handleChange(evt) {var
    value = evt.target.value;
    onChange(value);
  };

  return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(
        _OMSegmentedControl2.default.segmentedWrapper,
        className,
        _OMSegmentedControl2.default[theme]) },


      values.map(function (_ref) {var _cx, _cx2;var value = _ref.value,label = _ref.label;return (
          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(
              _OMSegmentedControl2.default.segmentedButton, (_cx = {}, _cx[
              _OMSegmentedControl2.default.active] = selectedValue == value, _cx), (_cx2 = {}, _cx2[
              _OMSegmentedControl2.default.twoInRow] = values.length === 2, _cx2)),

              key: label },

            inReduxForm ?
            _react2.default.createElement(_reduxForm.Field, {
              name: name,
              component: 'input',
              type: 'radio',
              value: value,
              id: name + '-' + value }) :

            _react2.default.createElement('input', {
              name: name,
              type: 'radio',
              value: value,
              id: name + '-' + value,
              onChange: handleChange }),


            _react2.default.createElement('label', { htmlFor: name + '-' + value }, label)));})));




};

OMSegmentedControl.propTypes = {
  values: _propTypes2.default.array,
  name: _propTypes2.default.string,
  selectedValue: _propTypes2.default.number,
  className: _propTypes2.default.string,
  inReduxForm: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  theme: _propTypes2.default.oneOf(['green', 'gray']) };exports.default =


OMSegmentedControl;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMSegmentedControl/OMSegmentedControl.js
// module id = 2790
// module chunks = 0